import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import * as infoPanelTypes from 'constants/infoPanelTypes';
import { setCenterPaneExtraInfoPanelActive, setShowTools } from 'actions';
import { clearCommerceWizardState } from 'actions/CommerceWizardActions';
import { extractPreviouslyRecommendedProducts, extractSelectedTicketIdFromState } from 'extractFromState';
import { setRecommendationAsPreviouslyTriggered } from 'actions/creatorsSync';
import {
  RecommendationContainer,
  LeftSideContainer,
  RightSideContainer,
  RecommendationsButton,
  ProductRecsTextWrapper,
  ProductsImgWrapper,
} from './ChatUIProductsTab.styles';
import { commerceRecosDisplayed } from 'analytics/mlEventAnalytics';

const ChatUIProductsTab = () => {
  const dispatch = useDispatch();

  const ticketId = useSelector((state) => extractSelectedTicketIdFromState(state));
  const savedPreviouslyRecommendedProducts = useSelector((state) => extractPreviouslyRecommendedProducts(state));

  /** ***  EVENT HANDLERS *****/

  const handleViewProductRecs = () => {
    // open to actions view
    dispatch(setShowTools(true));

    // dispatch ML analytics event
    commerceRecosDisplayed();

    // open commerce wizard
    dispatch(clearCommerceWizardState());
    dispatch(setCenterPaneExtraInfoPanelActive(true, null, null, infoPanelTypes.COMMERCE));
    dispatch(setRecommendationAsPreviouslyTriggered(ticketId));
  };

  /** *** RENDER FUNCS *****/

  const renderText = () => {
    if (!isEmpty(savedPreviouslyRecommendedProducts)) {
      return (
        <ProductRecsTextWrapper prevProductRecs={savedPreviouslyRecommendedProducts}>
          <h4>You or another expert already copied a product recommendation on this conversation.</h4>
        </ProductRecsTextWrapper>
      );
    }

    return (
      <ProductRecsTextWrapper>
        <h4>Action required - Please recommend a product</h4>
        <p>We found a few products that you can recommend to this customer. Please use when appropriate.</p>
      </ProductRecsTextWrapper>
    );
  };

  return (
    <RecommendationContainer>
      <LeftSideContainer prevProductRecs={savedPreviouslyRecommendedProducts}>
        <ProductsImgWrapper prevProductRecs={savedPreviouslyRecommendedProducts}>
          <img
            alt={'product recommendations exist'}
            src={
              savedPreviouslyRecommendedProducts
                ? 'images/chatUI/previously-made-product-rec.svg'
                : 'images/chatUI/product-recommendations-exist.svg'
            }
          />
        </ProductsImgWrapper>
        {renderText()}
      </LeftSideContainer>
      <RightSideContainer>
        {!savedPreviouslyRecommendedProducts && (
          <RecommendationsButton onClick={handleViewProductRecs}>Recommendations</RecommendationsButton>
        )}
      </RightSideContainer>
    </RecommendationContainer>
  );
};

export default ChatUIProductsTab;
